// utils/axiosConfig.js
// Created: 2026-03-11 14:30:00 EST
// Updated: 2026-03-13 09:30:05 EDT
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.2

import axios from 'axios';

/**
 * Suppress the CRA dev-overlay for transient Axios network errors.
 * The overlay fires on window 'unhandledrejection' — we intercept it
 * before CRA's handler sees it. Only AxiosError failures are
 * suppressed; real JS bugs still surface normally.
 */
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    const err = event.reason;
    if (
      err &&
      (err.isAxiosError || err.name === 'AxiosError')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true); // capture phase — runs before CRA's listener

  window.addEventListener('error', (event) => {
    const msg = String(event?.message || '');
    const err = event?.error;
    if (err && (err.isAxiosError || err.name === 'AxiosError')) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  }, true);
}

// Keep the interceptor so .catch() handlers in call-sites still fire normally.
axios.interceptors.response.use(
  res => res,
  err => Promise.reject(err)
);

export default axios;
